import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { Ampersand } from 'entities/Ampersand/ui/Ampersand/Ampersand'
import { IntegrationAircallSettings } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/IntegrationAircallSettings'
import { IntegrationSalesforceSettings } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationSalesforceSettings'
import { useIntegrationDetailsContext } from 'pages/settings/pages/integrations/context/integrationDetailsContext'
import { IntegrationsRoutes } from 'pages/settings/pages/integrations/route/type'
import { SettingsRoutes } from 'pages/settings/route/type'
import { IntegrationHubspotSettings } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationHubspotSettings/ui/IntegrationHubspotSettings'
import { IntegrationCalendlySettings } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationCalendlySettings/IntegrationCalendlySettings'
import { IntegrationActiveCampaignSettings } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationActiveCampaignSettings/IntegrationActiveCampaignSettings'
import { IntegrationKeapSettings } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationKeapSettings/IntegrationKeapSettings'
import { IntegrationSlackSettings } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationSlackSettings/IntegrationSlackSettings'
import { IntegrationPipedriveSettings } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationPipedriveSettings/IntegrationPipedriveSettings'
import { IntegrationIntercomSettings } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationIntercomSettings/IntegrationIntercomSettings'
import { IntegrationZohoSettings } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationZohoSettings/IntegrationZohoSettings'

export const IntegrationSettings = observer(() => {
  const { integration, isLoading } = useIntegrationDetailsContext()

  if (!integration) return null
  if (!integration.isSettingsAvailable) {
    uiStore.changeRouteViaVue({
      path: `/${SettingsRoutes.root}/${IntegrationsRoutes.root}/${integration.key}/${IntegrationsRoutes.description}`,
      method: 'replace',
    })
  }

  const Component = useMemo(() => {
    if (integration.is_ampersand && integration.key !== 'zoho') {
      return Ampersand
    }
    switch (integration.key) {
      case 'hubspot':
        return IntegrationHubspotSettings
      case 'salesforce':
        return IntegrationSalesforceSettings
      case 'calendly':
        return IntegrationCalendlySettings
      case 'activecampaign':
        return IntegrationActiveCampaignSettings
      case 'infusionsoft':
        return IntegrationKeapSettings
      case 'slack':
        return IntegrationSlackSettings
      case 'pipedrive':
        return IntegrationPipedriveSettings
      case 'intercom':
        return IntegrationIntercomSettings
      case 'aircall':
        return IntegrationAircallSettings
      case 'zoho':
        return IntegrationZohoSettings
      default: {
        return function EmptyHolder() {
          return <div>{integration.name} settings page not exist</div>
        }
      }
    }
  }, [integration])

  return (
    <FullPageWrapper>
      {isLoading ? (
        <SpinnerLoader ariaLabel={'IntegrationSettings'} />
      ) : (
        <Component integration={integration} />
      )}
    </FullPageWrapper>
  )
})
